import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/storage-hub/capture-storage/database/$id/measurements")({
  staticData: {
    title: "database.captureStorageDetailLayout.measurements",
  },
});
